import { enGB } from 'date-fns/locale';

export const enGBLocale = { ...enGB, options: { ...enGB.options, weekStartsOn: 1 } };
